import React from 'react';

export const LoaderIcon = ({ fill, className, width, height }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		fill={fill}
		className={className}
		width={width}
		height={height}
		viewBox="0 0 135 140"
	>
		<rect y="17.9753" width="15" height="104.049" rx="6">
			<animate
				attributeName="height"
				begin="0.5s"
				dur="1s"
				values="120;110;100;90;80;70;60;50;40;140;120"
				calcMode="linear"
				repeatCount="indefinite"
			/>
			<animate
				attributeName="y"
				begin="0.5s"
				dur="1s"
				values="10;15;20;25;30;35;40;45;50;0;10"
				calcMode="linear"
				repeatCount="indefinite"
			/>
		</rect>
		<rect x="30" y="30.4753" width="15" height="79.0494" rx="6">
			<animate
				attributeName="height"
				begin="0.25s"
				dur="1s"
				values="120;110;100;90;80;70;60;50;40;140;120"
				calcMode="linear"
				repeatCount="indefinite"
			/>
			<animate
				attributeName="y"
				begin="0.25s"
				dur="1s"
				values="10;15;20;25;30;35;40;45;50;0;10"
				calcMode="linear"
				repeatCount="indefinite"
			/>
		</rect>
		<rect x="60" width="15" height="54.0494" rx="6" y="42.9753">
			<animate
				attributeName="height"
				begin="0s"
				dur="1s"
				values="120;110;100;90;80;70;60;50;40;140;120"
				calcMode="linear"
				repeatCount="indefinite"
			/>
			<animate
				attributeName="y"
				begin="0s"
				dur="1s"
				values="10;15;20;25;30;35;40;45;50;0;10"
				calcMode="linear"
				repeatCount="indefinite"
			/>
		</rect>
		<rect x="90" y="30.4753" width="15" height="79.0494" rx="6">
			<animate
				attributeName="height"
				begin="0.25s"
				dur="1s"
				values="120;110;100;90;80;70;60;50;40;140;120"
				calcMode="linear"
				repeatCount="indefinite"
			/>
			<animate
				attributeName="y"
				begin="0.25s"
				dur="1s"
				values="10;15;20;25;30;35;40;45;50;0;10"
				calcMode="linear"
				repeatCount="indefinite"
			/>
		</rect>
		<rect x="120" y="17.9753" width="15" height="104.049" rx="6">
			<animate
				attributeName="height"
				begin="0.5s"
				dur="1s"
				values="120;110;100;90;80;70;60;50;40;140;120"
				calcMode="linear"
				repeatCount="indefinite"
			/>
			<animate
				attributeName="y"
				begin="0.5s"
				dur="1s"
				values="10;15;20;25;30;35;40;45;50;0;10"
				calcMode="linear"
				repeatCount="indefinite"
			/>
		</rect>
	</svg>
);
